import { cardDefinitions, groups, type CardDefinition } from '@lafayette/content';
import { Card, CardBack } from '@lafayette/ui';

import styles from './GalleryPage.module.css';

const SECTIONS: { kind: CardDefinition['kind']; title: string }[] = [
  { kind: 'property', title: 'Property cards' },
  { kind: 'propertyWildcard', title: 'Property wildcards' },
  { kind: 'action', title: 'Action cards' },
  { kind: 'rent', title: 'Rent cards' },
  { kind: 'money', title: 'Money cards' },
];

/**
 * Development-only view of every unique card face and how many copies the deck
 * ships with. Used to eyeball the deck against the printed cards.
 */
export function GalleryPage() {
  const total = cardDefinitions.reduce((sum, c) => sum + c.copies, 0);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Card gallery</h1>
        <p className={styles.summary} data-testid="deck-total">
          {cardDefinitions.length} unique faces &middot; {total} cards in the deck
        </p>
      </header>

      {SECTIONS.map((section) => {
        const cards = cardDefinitions.filter((c) => c.kind === section.kind);
        const count = cards.reduce((sum, c) => sum + c.copies, 0);
        return (
          <section key={section.kind} className={styles.section}>
            <h2 className={styles.sectionTitle}>
              {section.title} <span className={styles.count}>{count}</span>
            </h2>
            <div className={styles.grid}>
              {cards.map((card) => (
                <figure key={card.id} className={styles.item} data-gallery-card={card.id}>
                  <Card definitionId={card.id} size="md" />
                  <figcaption className={styles.caption}>
                    {card.title}
                    <span className={styles.copies}>&times;{card.copies}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </section>
        );
      })}

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Card back &amp; groups</h2>
        <div className={styles.grid}>
          <figure className={styles.item}>
            <CardBack size="md" />
            <figcaption className={styles.caption}>Card back</figcaption>
          </figure>
          {groups.map((group) => (
            <figure key={group.id} className={styles.item}>
              <div
                className={styles.swatch}
                style={{ background: group.color, color: group.onColor }}
              >
                {group.label}
              </div>
              <figcaption className={styles.caption}>
                {group.size} cards &middot; rent {group.rent.join(' / ')}
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </main>
  );
}
